import {createAsyncThunk} from "@reduxjs/toolkit";
import axios from "axios";
import {USER_LOCALSTORAGE_KEY} from "shared/const/localstorage";
import {deleteTestAction} from "features/model/slice/test/success-test/delete-test/deleteTest";
import {
    preservedTest,
    preservedTestAction
} from "features/model/slice/test/success-test/preserved-test/preservedTestSlice";
import {getModalTests} from "features/model/slice/test/get-test/getTestSlice";
import {setBackData} from "features/model/slice/create-test/create-test-form/createTestForm";
import {fetchTest} from "features/model/service/test/get-test/fetchTest";



export const fetchCreateTest = createAsyncThunk(
    'test/createTest',
    async ({ testId, requestData }: { testId: string | undefined; requestData: any }, thunkAPI) => {
        try {
            const authToken = localStorage.getItem(USER_LOCALSTORAGE_KEY);
            if (!authToken) {
                throw new Error('No token found in localStorage.');
            }
            const { token } = JSON.parse(authToken);

            const response = await axios.put(
                `/api/tests/${testId}`,
                requestData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (response.data.success) {
                thunkAPI.dispatch(preservedTestAction(response.data));

                thunkAPI.dispatch(setBackData(response.data.data.model));
            } else {
                throw new Error('Ошибка сохранения урока.');
            }
            return response.data;
        } catch (error) {
            console.error('Произошла ошибка:', error);
            throw error;
        }
    }
);

